import lozad from 'lozad';
export default {
  init() {
    const observer = lozad();
    observer.observe();

    //Shrink effect on Megamenu on Scroll
    window.onscroll = function() {myFunction()};

    let header = document.getElementById('aecom-main-menu');

    let sticky = header.offsetTop;

    function myFunction() {
      if (window.pageYOffset > sticky) {
        header.classList.add('shrink');
      } else {
        header.classList.remove('shrink');
      }
    }

    $('#high-contrast-toggle').on('click', function(){
      var toggled = localStorage.getItem('toggleHighContrast');
      var logo_dark = window.location.origin + '/wp-content/plugins/aecom-components/images/aecom-logo-dark.svg';
      var logo_light = window.location.origin + '/wp-content/plugins/aecom-components/images/aecom-logo-light.svg';
      if(toggled == 'true'){
        localStorage.setItem('toggleHighContrast', false);
        $('body').removeClass('high-contrast');
        $('#aecom-logo img').attr('src', logo_dark);
        $('.aecom-logo-mobile img').attr('src', logo_dark);
        $('#high-contrast-toggle i').removeClass('fa-eye');
        $('#high-contrast-toggle i').addClass('fa-low-vision');
     } else {
        localStorage.setItem('toggleHighContrast', true);
         $('body').addClass('high-contrast');
         $('#aecom-logo img').attr('src', logo_light);
         $('.aecom-logo-mobile img').attr('src', logo_light);
         $('#high-contrast-toggle i').removeClass('fa-low-vision');
         $('#high-contrast-toggle i').addClass('fa-eye');
     }
      
    });

    $(document).ready(function (){
      var toggled = localStorage.getItem('toggleHighContrast');
      var logo_dark = window.location.origin + '/wp-content/plugins/aecom-components/images/aecom-logo-dark.svg';
      var logo_light = window.location.origin + '/wp-content/plugins/aecom-components/images/aecom-logo-light.svg';
      if(toggled == 'true'){
         $('body').addClass('high-contrast');
         $('#aecom-logo img').attr('src', logo_light);
         $('.aecom-logo-mobile img').attr('src', logo_light);
         $('#high-contrast-toggle i').removeClass('fa-low-vision');
         $('#high-contrast-toggle i').addClass('fa-eye');
      } else {
          $('body').removeClass('high-contrast');
          $('#aecom-logo img').attr('src', logo_dark);
          $('.aecom-logo-mobile img').attr('src', logo_dark);
          $('#high-contrast-toggle i').removeClass('fa-eye');
          $('#high-contrast-toggle i').addClass('fa-low-vision');
      }

      // Equalize Megamenu Height (added timeout to fetch the actual height)

      setTimeout(function() { 
        var megaSize = $('#aecom-main-menu #mega-menu-mega-menu .mega-menu-item-has-children ul.mega-sub-menu');
        var highest = 0;
        var windowWidth = $(window).width();
        megaSize.each(function() {
          highest = Math.max(highest, parseFloat($(this).height()));
        });
        if(windowWidth >= 1200) {
          megaSize.css('height', highest);
        }
      }, 2000);

      $( window ).resize(function() {
        var megaSize = $('#aecom-main-menu #mega-menu-mega-menu .mega-menu-item-has-children ul.mega-sub-menu');
        var highest = 0;
        var windowWidth = $(window).width();
        megaSize.each(function() {
          highest = Math.max(highest, parseFloat($(this).height()));
        });
        if(windowWidth >= 1200) {
          megaSize.css('height', highest);
        } else {
          megaSize.css('height', 'auto');
        }
      });

      // Lazyload Megamenu Images on hover
      $('#mega-menu-mega-menu li .mega-menu-link').each(function() {
        var megaImage = $(this).next('.mega-sub-menu').find('.megamenu-mini-img');
        var megaFeaturedImg = $(this).next('.mega-sub-menu').find('.megamenu-item-img-bg');
        $(this).hover(function() {
          if(!$(this).hasClass('lazy-loaded')) {
            $(this).addClass('lazy-loaded');
            megaFeaturedImg.css('background-image', 'url(' + megaFeaturedImg.attr('data-bg') + ')');
            megaImage.each(function(){
              if($(this).length) {
                var megaImageElement = '<img src="' + $(this).attr('data-img') + '" width="600" height="360" />';
                $(this).html(megaImageElement);
              }
            });
          }
        })
      });

    });

    $('.mega-toggle-block').on('click', function(){
      $('body').toggleClass('scroll-locked');
    });

    $('#addtl-contacts-button').on('click', function() {
      $('.addtl-contacts-sidebar').toggleClass('expand-contact');
      $(document).on('click', function(e) {
        if ($(e.target).is('#addtl-contacts-button') === false) {
          $('.addtl-contacts-sidebar').removeClass('expand-contact');
        }
      });
    });

    $('.msp-filters .filter, .press-releases-filter-set .filter').each(function() {
      $(this).on('click', function(){
        // $('.filter').removeClass('expand-filter');
        if($(this).hasClass('expand-filter')) {
          $(this).removeClass('expand-filter');
        } else {
          $('.filter').removeClass('expand-filter')
          $(this).addClass('expand-filter');
        }
      });
    });

    $(document).on('click', function(e) {
      if ($(e.target).is('.filter-title') === false) {
        $('.filter').removeClass('expand-filter');
      }
    });

  // Content Animation
  // Check if viewport width is at least 1181px
    if (window.matchMedia('(min-width: 1181px)').matches) {
      // Function to handle scroll events
      var handleScroll = function() {
        var windowHeight = $(window).height();
        var windowTop = $(window).scrollTop();
        
        // Iterate over each .animated-block element
        if($('.animated-content').length > 0) {
          $('.animated-content').each(function () {
            var element = $(this);
            var elementTop = element.offset().top + 200 || 0;
            var animationStyle;
            if(element.hasClass('fade-in-up')) {
              animationStyle = 'animate__fadeInUp';
            } else if(element.hasClass('fade-in-left')) {
              animationStyle = 'animate__fadeInLeft';
            } else if(element.hasClass('fade-in-right')) {
              animationStyle = 'animate__fadeInRight';
            } else if(element.hasClass('fade-in-down')) {
              animationStyle = 'animate__fadeInDown';
            } else {
              animationStyle = 'animate__fadeIn';
            }

            
            // Check if the element is in the viewport
            if (elementTop < windowTop + windowHeight && elementTop + element.height() > windowTop) {
              // Add animation classes to child elements if not already animated
              element.each(function() {
                if (!element.hasClass('animate__animated')) {
                  element.addClass('animate__animated ' + animationStyle);
                }
              });
            }
          });
        }
      };
      
      // Bind handleScroll to the scroll event
      $(window).on('scroll', handleScroll);
      // Bind handleScroll to the scroll event
      $(window).on('load', handleScroll);
    }


    if($('#scrollToTopBtn').length > 0) {
      var docHeight = $(document).height() - 300;
      var windowHeight = $(window).height();
      var scrollTrigger = Math.round(windowHeight * 0.6);
      $(window).on('scroll', function() {
        if(docHeight > 2100) {
          if ($(this).scrollTop() > scrollTrigger) {
              $('#scrollToTopBtn').fadeIn();
          } else {
              $('#scrollToTopBtn').fadeOut();
          }
        }
      });
      $('#scrollToTopBtn').on('click', function() {
          $('html, body').animate({ scrollTop: 0 }, 'fast');
          return false;
      });
    }

    if ($('.aecom-full-width-wistia').length || $('.aecom-video-wistia').length) {
        // Create a new script element
        const wistiaScript = document.createElement('script');
        // Set the source of the script
        wistiaScript.src = '//fast.wistia.com/assets/external/E-v1.js';
        // Set async attribute if needed
        wistiaScript.async = true; 
        // Append the script before the closing body tag
        document.body.append(wistiaScript);
        console.log('Wistia script loaded');
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js